/**
 * Tooltip transform.
 *
 * Controls shared vs item tooltip trigger and crosshair style.
 */
import type { EChartsOption } from 'echarts';
import type { ChartStyleState } from '../../../../edit/visualConfig';
import { isSingleObject } from './helpers';

export function applyTooltip(option: EChartsOption, vc: ChartStyleState): EChartsOption {
  const result = { ...option };
  if (!isSingleObject(result.tooltip)) return result;

  const originalTooltip = result.tooltip as any;
  const tt = { ...originalTooltip };
  tt.trigger = vc.sharedTooltip ? 'axis' : 'item';

  if (originalTooltip.axisPointer) {
    tt.axisPointer = {
      ...originalTooltip.axisPointer,
      type: vc.crosshair ? 'cross' : 'line',
      ...(vc.crosshair
        ? { lineStyle: { ...originalTooltip.axisPointer?.lineStyle, type: 'dashed' } }
        : {}),
    };
  }

  result.tooltip = tt;
  return result;
}